$(document).ready(function() {
	$('.toronto-features-row').on('click', function () {
		$(this).toggleClass('toronto-features-row-active').siblings().removeClass('toronto-features-row-active');
	});
});

// Parallax effect
var onScroll = function() {
	var scrollTop = $(this).scrollTop();
	$('.parallax-image').each(function(index, elem) {
	  var $elem = $(elem);
	  $elem.find('img.par-effect').css('top', scrollTop - $elem.offset().top);
	});
};
onScroll.apply(window);
$(window).on('scroll', onScroll);